import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const TRADER_TIER_COLORS = {
  1: '#4A5A4A',
  2: '#1E7A18',
  3: '#16A80C',
  4: '#15E402',
  5: '#3BFF1E',
  6: '#84FF6E',
  7: '#CFFFC4',
};

export function tierColor(level) {
  return TRADER_TIER_COLORS[level] || '#4A5A4A';
}

export function fmtDuration(seconds) {
  const s = Math.max(0, parseInt(seconds || 0, 10));
  const m = Math.floor(s / 60);
  const r = s % 60;
  if (m >= 60) {
    const h = Math.floor(m / 60);
    return `${h}h ${m % 60}m`;
  }
  return `${m}:${String(r).padStart(2, '0')}`;
}

export function fmtMinutes(mins) {
  const m = Math.max(0, parseInt(mins || 0, 10));
  if (m >= 60) return `${(m / 60).toFixed(1)}h`;
  return `${m}m`;
}

export function timeAgo(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString();
}
